<section *ngIf="showDemoModeBanner | async" class="app-banner test-mode" [class.top-index]="!rightSidenav.opened">
        <p>{{'Test Mode'}}</p>
        <p>{{'You\'re using test data'}}</p>
</section>

<mat-sidenav-container [class.layout-container]="true"
                       [class.with-banner]="showDemoModeBanner | async"
                       [class.mobile-layout]="mobileMode$ | async"
                       [class.tablet-layout]="tabletMode$ | async">
    <mat-sidenav #leftSidenav position="start"
                 [mode]="(mobileMode$ | async) ? 'over' : 'side'"
                 [opened]="!(mobileMode$ | async)">
        <div *ngIf="!(mobileMode$ | async)" class="sidenav-logo">
            <a [attr.aria-label]="routerLogoButton.ariaLabel"
               [routerLink]="routerLogoButton.route">
                <img class="img" [alt]="routerLogoButton.label" [attr.src]="appLogoSrc"/>
            </a>
        </div>

        <app-header-search *ngIf="mobileMode$ | async"></app-header-search>

        <app-sidenav-navigation></app-sidenav-navigation>
    </mat-sidenav>

    <mat-toolbar *ngIf="mobileMode$ | async" class="layout-header">
        <button mat-icon-button disableRipple animated
                class="sidenav-toggle"
                [attr.aria-label]="'PayHOA app navigation'"
                (click)="leftSidenav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>

        <flex-spacer></flex-spacer>

        <a class="header-logo"
           mat-button disableRipple
           [attr.aria-label]="routerLogoButton.ariaLabel"
           [routerLink]="routerLogoButton.route">
            <img class="img" [alt]="routerLogoButton.label" [attr.src]="appLogoSrc"/>
        </a>

        <flex-spacer></flex-spacer>

        <app-header-menu></app-header-menu>
    </mat-toolbar>

    <mat-toolbar *ngIf="!(mobileMode$ | async)" class="layout-header">
        <app-header-search></app-header-search>

        <flex-spacer></flex-spacer>

        <app-header-menu></app-header-menu>
    </mat-toolbar>

    <div class="layout-content">
        <router-outlet></router-outlet>
    </div>

    <mat-sidenav #rightSidenav position="end" disableClose autoFocus="false">
        <app-sidenav-content></app-sidenav-content>
    </mat-sidenav>
</mat-sidenav-container>
